import React from 'react';

export const PositionOverview = ({ position }) => {
  const formatCurrency = (value) => {
    return `$${Number(value).toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    })}`;
  };

  const formatBTC = (value) => {
    return `${Number(value).toFixed(4)} BTC`;
  };

  const getPnLColor = (pnl) => {
    return pnl >= 0 ? 'text-green-400' : 'text-red-400';
  };

  return (
    <div className="bg-atticus-navy-800 rounded-xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-white font-bold text-lg">Current Position</h4>
        <div className={`px-3 py-1 rounded-full text-sm font-medium ${
          position.side === 'long' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'
        }`}>
          {position.side.toUpperCase()}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="text-center">
          <div className="text-gray-400 text-sm">Position Size</div>
          <div className="text-white font-bold text-lg">
            {formatBTC(Math.abs(position.size))}
          </div>
        </div>

        <div className="text-center">
          <div className="text-gray-400 text-sm">Entry Price</div>
          <div className="text-white font-bold text-lg">
            {formatCurrency(position.entry_price)}
          </div>
        </div>

        <div className="text-center">
          <div className="text-gray-400 text-sm">Mark Price</div>
          <div className="text-white font-bold text-lg">
            {formatCurrency(position.mark_price)}
          </div>
        </div>

        <div className="text-center">
          <div className="text-gray-400 text-sm">Unrealized P&L</div>
          <div className={`font-bold text-lg ${getPnLColor(position.unrealized_pnl)}`}>
            {formatCurrency(position.unrealized_pnl)}
          </div>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-600">
        <div className="flex justify-between items-center">
          <span className="text-gray-400">Leverage:</span>
          <span className="text-white font-medium">{position.leverage}x</span>
        </div>
      </div>
    </div>
  );
};
